import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "react-feather";

// Browser-history back instead of a hardcoded link-page destination - a
// detail page can now be reached from more than one place (its own list,
// or a cross-cutting drill-down like the Stock Movement Report), and a
// fixed target silently sends the user to the wrong page when they arrived
// from somewhere else. A <button> (an `href="#"` anchor isn't a real,
// navigable address, which trips eslint-plugin-jsx-a11y's anchor-is-valid
// rule) styled as `btn-link` so it keeps the same link color/underline
// react-router's own <Link> got from this app's $link-color.
const BackButton = ({ label = "Back", className = "d-inline-flex align-items-center mb-2" }) => {
  const navigate = useNavigate();
  return (
    <button type="button" className={`btn btn-link p-0 ${className}`} onClick={() => navigate(-1)}>
      <ArrowLeft size={16} className="me-1" /> {label}
    </button>
  );
};

export default BackButton;
